import { render, staticRenderFns } from "./displayAdvertisingStyle.vue?vue&type=template&id=6ba40132&scoped=true"
import script from "./displayAdvertisingStyle.vue?vue&type=script&lang=js"
export * from "./displayAdvertisingStyle.vue?vue&type=script&lang=js"
import style0 from "./displayAdvertisingStyle.vue?vue&type=style&index=0&id=6ba40132&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba40132",
  null
  
)

export default component.exports